export default __webpack_public_path__ + "static/N0298-733fa2ad4fc025ed64115cea268d643d.png";